<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="maintenance-create-ds-title">
      {{$t('maintenance.data_subjects.create.title')}}
    </h4>

    <div class="card">
      <div class="card-body">
        <div class="form-centered">
          <b-alert v-if="error.length"
                   show
                   variant="danger"
                   qid="create-ds-error"
          >
            {{ error }}
          </b-alert>
          <b-form @submit="formSubmit" qid="create-ds-form">
            <div class="form-container">
              <b-form-group>
                <label qid="create-ds-name-label">
                  {{ $t('maintenance.data_subjects.create.name_label') }}
                </label>
                <b-form-input
                  qid="create-ds-form-name"
                  type="text"
                  v-model="dsForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.data_subjects.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-ds-description-label">
                  {{ $t('maintenance.data_subjects.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-ds-form-description"
                  v-model="dsForm.description"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('maintenance.data_subjects.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group :class="{'multiselect--show-input': nosInput.length}">
                <label qid="create-ds-type-label">
                  {{ $t('maintenance.data_subjects.create.subjects_label') }}
                </label>
                <multiselect
                    v-model="dsForm.number_of_subjects"
                    :options="nosItems"
                    :placeholder="$t('maintenance.data_subjects.create.subjects_placeholder')"
                    label="number_of_subjects"
                    :preserveSearch="true"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    @search-change="handleNosInput"
                    qid="create-ds-form-subjects"
                >
                  <template slot="noResult" slot-scope="props">
                    {{ $t('maintenance.data_subjects.create.subjects_no_results') }}
                  </template>
                </multiselect>
              </b-form-group>
            </div>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="goToList"
                        qid="create-ds-cancel-button"
              >
                {{ $t('maintenance.data_subjects.create.cancel') }}
              </b-button>
              <b-button type="submit"
                        class="mt-3 ml-3"
                        :disabled="buttonDisabled"
                        variant="success"
                        qid="create-ds-submit-button"
              >
                <span v-if="buttonDisabled" class="mr-1">
                  <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                </span>
                {{ $t('maintenance.data_subjects.create.submit') }}
              </b-button>
            </div>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'CreateDataSubject',
    data: function() {
      return {
        breadcrumbItems: [
          {
            text: this.$t('dashboard.title'),
            to: '/'
          },
          {
            text: this.$t('maintenance.title'),
            to: '/maintenance'
          },
          {
            text: this.$t('maintenance.data_subjects.title'),
            to: '/maintenance/data-subjects'
          },
          {
            text: this.$t('maintenance.data_subjects.create.title'),
            active: true
          }
        ],
        dsForm: {
          name: '',
          description: '',
          number_of_subjects: [],
          client:'',
        },
        error: '',
        nosItems: [],
        nosInput: '',
        buttonDisabled: false
      }
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        this.loadSubjects();
      }
    },
    methods: {
      goToList() {
        this.$router.push('/maintenance/data-subjects')
      },
      handleNosInput(input) {
        this.nosInput = input;
      },
      formSubmit(evt) {
        this.buttonDisabled = true;
        let formData = new FormData();

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        formData.append("name", this.dsForm.name);
        formData.append("description", this.dsForm.description);
        formData.append("client", this.getClient.slug);

        // Additional check - if number_of_subjects is selected, append it to form data
        if (this.dsForm.number_of_subjects && this.dsForm.number_of_subjects.number_of_subjects) {
          formData.append("number_of_subjects", this.dsForm.number_of_subjects.number_of_subjects);
        } else {
          if (this.nosInput && this.nosInput.length) {
            formData.append("number_of_subjects", this.nosInput);
          }
        }

        // Post FormData object to API
        piincHttp.post('/data-subjects', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.data_subjects.create.success'))
          self.buttonDisabled = false;
          self.goToList();
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
            if (error.data.errors.number_of_subjects) {
              self.error += ' ' + error.data.errors.number_of_subjects[0]
            }
          }
        })
      },
      loadSubjects() {
        let self = this;
        if (this.getClient && this.getClient.slug) {
          piincHttp.get('/data-subjects/subjects', { params:
            {
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.nosItems = response.data
            if (self.nosItems && !self.nosItems.length) {
              self.nosItems.push({number_of_subjects: self.$t('system.no_results'), $isDisabled: true})
            }
          }, function() {});
        }
      }
    },
    components: {

    },
    created () {
      this.loadSubjects();
    }

  }
</script>
